import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default function useOptions() {
  const { t } = useTranslation();

  const exitTimelineOptions = useMemo(
    () => [
      { value: 'asap', label: t('asap') },
      { value: 'within_one_year', label: t('withinOneYear') },
      { value: 'one_to_three_years', label: t('oneToThreeYears') },
      { value: 'three_to_five_years', label: t('threeToFiveYears') },
    ],
    [t],
  );

  const hasGmOptions = useMemo(
    () => [
      { value: 'yes', label: t('yesGm') },
      { value: 'no', label: t('noGm') },
    ],
    [t],
  );

  const profitMeasureOptions = useMemo(
    () => [
      { value: 'ebitda', label: t('ebitda') },
      { value: 'ebit', label: t('ebit') },
      { value: 'pebitda', label: t('pebitda') },
      { value: 'operating_profit', label: t('operatingProfit') },
      { value: 'npat', label: t('npat') },
    ],
    [t],
  );

  const businessPerformanceOptions = useMemo(
    () => [
      { value: 'growing', label: t('growing') },
      { value: 'stable', label: t('stable') },
      { value: 'shrinking', label: t('shrinking') },
      { value: 'depressed', label: t('depressed') },
    ],
    [t],
  );

  const consideredAspectsOfDealOptions = useMemo(
    () => [
      {
        value: 'providing_financing_arrangement',
        label: t('providing_financing_arrangement'),
      },
      {
        value: 'deferred_payment_or_earnout',
        label: t('deferred_payment_or_earnout'),
      },
      { value: 'sale_of_percentage', label: t('sale_of_percentage') },
    ],
    [t],
  );

  const isTheCommercialFreeholdForSaleOptions = useMemo(
    () => [
      { value: 'yes', label: t('yesFreehold') },
      { value: 'no', label: t('noFreehold') },
    ],
    [t],
  );

  const isThereLeaseOptions = useMemo(
    () => [
      { value: 'yes', label: t('yesLease') },
      { value: 'no', label: t('noLease') },
    ],
    [t],
  );

  return {
    exitTimelineOptions,
    hasGmOptions,
    profitMeasureOptions,
    businessPerformanceOptions,
    consideredAspectsOfDealOptions,
    isTheCommercialFreeholdForSaleOptions,
    isThereLeaseOptions,
  };
}
